import type { ResolvedTheme } from './theme.service';

export const THEME_COOKIE = 'lumir_theme';

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
const SHARED_PARENT_DOMAINS = ['.lumir.cloud', '.lumir.photo'];
const COOKIE_VALUE = new RegExp(`(?:^|;\\s*)${THEME_COOKIE}=([^;]*)`);

// Parent domain carries the choice between product subdomains; any other host (localhost) keeps a host-only cookie.
export function themeCookieAttributes(hostname: string, protocol: string): string {
  const parent = SHARED_PARENT_DOMAINS.find(domain => hostname.endsWith(domain));
  const domain = parent ? `; Domain=${parent}` : '';
  const secure = protocol === 'https:' ? '; Secure' : '';
  return `Path=/; Max-Age=${ONE_YEAR_SECONDS}; SameSite=Lax${domain}${secure}`;
}

export function readThemeCookie(document: Document): ResolvedTheme | null {
  try {
    const value = COOKIE_VALUE.exec(document.cookie)?.[1];
    return value === 'light' || value === 'dark' ? value : null;
  } catch {
    return null;
  }
}

export function writeThemeCookie(document: Document, theme: ResolvedTheme): void {
  try {
    const location = document.defaultView?.location;
    document.cookie = `${THEME_COOKIE}=${theme}; ${themeCookieAttributes(location?.hostname ?? '', location?.protocol ?? '')}`;
  } catch {
    /* cookies disabled — the choice still lives in localStorage */
  }
}
